// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__1ZnSQ","title":"ErrorPage_title__xLqUk","info":"ErrorPage_info__3HAm4","marginTopExtra":"ErrorPage_marginTopExtra__26pRk"};